export default function ChatgptBrainstorming() {
  return <h2>Chatgpt Brainstorming</h2>;
}
